import { twMerge } from 'tailwind-merge'

const variants = {
  primary:
  'bg-gradient-to-br from-white to-slate-100/70 text-black',
  action:
    'bg-gradient-to-br from-white to-slate-100/70 text-primary',
  outline:
    'border-[2px] bg-primary/10 hover:bg-primary/50  border-primary/30 border-b-[px] text-primary/80',
  discreet: 'bg-white/5 *:muted *:hover:unmuted',
  naked:
    'bg-gradient-to-t from-primary/10 hover:bg-zinc-500/0 border-primary/30 border-t-[2px] border-b-[px]  text-white font-semibold',
  destructive: 'bg-zinc-800 text-red-600'
}

const Button = ({
  className,
  children,
  variant,
  disabled,
  onClick,
  type = 'button',
  ...props
}) => {

  const handleClick = () => {
    if(!onClick) return
    else onClick()
  }
  return (
    <button
      onClick={handleClick}
      type={type}
      className={twMerge(
        ' !font-arial text-[1rem] hover:scale-[.98] quicker w-fit max-w-64= relative flex items-center justify-center rounded-lg overflow-hidden border border-transparent px-5 py-1 min-h-[44px] min-w-[44px] disabled:cursor-not-allowed disabled:opacity-30 whitespace-nowrap !font-[500] transition',
        className,
        variants[variant]
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
